// extracted by css-extract-rspack-plugin
export default {"pagination-wrapper":"oKpAN8","paginationWrapper":"oKpAN8"};